import { CardList } from '../card-list/card-list';
import { SacCardSkeleton } from '../sac-card/sac-card';

type SacListSkeletonProps = {
  itemCount?: number;
  columns?: number;
  columnsSm?: number;
  columnsMd?: number;
  columnsLg?: number;
};

export const SacListSkeleton: React.FC<SacListSkeletonProps> = ({
  itemCount = 12,
  columns = 1,
  columnsSm = 2,
  columnsMd = 2,
  columnsLg = 3,
}: SacListSkeletonProps) => {
  return (
    <CardList
      columns={columns}
      columnsSm={columnsSm}
      columnsMd={columnsMd}
      columnsLg={columnsLg}
      classNameGap="gap-y-roomy-xs gap-x-comfy-xl"
    >
      {Array.from({ length: itemCount }, (_, index) => (
        <SacCardSkeleton key={index} />
      ))}
    </CardList>
  );
};
